import { buildEnvironment, Environment } from './environment.type';

export const environment: Environment = buildEnvironment({
    production: true,
    apiUrl: 'https://webapi.aristotle.com',
});
